import { render } from "./DropdownProfitSharingPlans.vue?vue&type=template&id=5895dec1"
import script from "./DropdownProfitSharingPlans.vue?vue&type=script&lang=ts"
export * from "./DropdownProfitSharingPlans.vue?vue&type=script&lang=ts"
script.render = render

export default script